// This file contains utility functions for the web application.
import { Popover, Tooltip } from "bootstrap";
// Utility function to asynchronously wait for a specified number of milliseconds
export async function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function initializePopovers() {
    // Initialize all popovers
    const popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'));
    [...popoverTriggerList].map((popoverTriggerEl) => new Popover(popoverTriggerEl));
    // Initialize all tooltips
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
}
Document.prototype.getHtmlElementById = function getHtmlElementById(id) {
    const element = document.getElementById(id);
    if (!element) {
        return null;
    }
    return element;
};
Document.prototype.queryHtmlElements = function queryHtmlElements(selector) {
    const elements = document.querySelectorAll(selector);
    return elements ? Array.from(elements) : [];
};
Element.prototype.queryHtmlElements = function queryHtmlElements(selector) {
    const elements = this.querySelectorAll(selector);
    return elements ? Array.from(elements) : [];
};
